import { Box, RadioGroup } from "@chakra-ui/react";

import { RadioOptionType as SelectOptionType } from "./types";

type RadioOptionProps<T extends string> = SelectOptionType<T> & {
  name: string;
  onChangeValue: (value: boolean) => void;
};

export const RadioOption = <T extends string>({
  name,
  value,
  label,
  disabled,
}: RadioOptionProps<T>) => {
  return (
    <Box _hover={{ backgroundColor: "gray.100" }} borderRadius="md">
      <RadioGroup.Item
        id={`${name}_${value}`}
        px={4}
        py={2}
        value={value}
        disabled={disabled}
        width={"100%"}
        cursor={"pointer"}
      >
        <RadioGroup.ItemHiddenInput />
        <RadioGroup.ItemIndicator
          width="16px"
          height="16px"
          position="relative"
          _checked={{ borderColor: "blue.500", backgroundColor: "blue.500" }}
          _disabled={{
            backgroundColor: "gray.200",
            _checked: { color: "gray.900", borderColor: "gray.300", backgroundColor: "gray.300" },
          }}
          borderWidth={2}
        />
        <RadioGroup.ItemText>{label}</RadioGroup.ItemText>
      </RadioGroup.Item>
    </Box>
  );
};
